import { render } from "./LoadingForm.vue?vue&type=template&id=2849c4b7&scoped=true"
const script = {}

import "./LoadingForm.vue?vue&type=style&index=0&id=2849c4b7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2849c4b7"]])

export default __exports__